import { defineMessages } from 'react-intl';

export default defineMessages({
  whereToGo: {
    id: 'locationSection.whereToGo',
    defaultMessage: 'where to go',
  },
  nearbyTips: {
    id: 'locationSection.nearbyTips',
    defaultMessage: 'nearby tips',
  },
  youBring: {
    id: 'locationSection.youBring',
    defaultMessage: 'what you need to bring',
  },
  notes: {
    id: 'locationSection.notes',
    defaultMessage: 'please note',
  },
  cancellationPolicy: {
    id: 'locationSection.cancellationPolicy',
    defaultMessage: 'cancellation policy',
  },
  policyInfo: {
    id: 'locationSection.policyInfo',
    defaultMessage: 'All bookings have a 3% booking fee included which will not be refunded upon cancellation',
  },
  policyLink: {
    id: 'locationSection.policyLink',
    defaultMessage: 'Read our full cancellation policy.',
  },
  pricingBreakdownTitle: {
    id: 'locationSection.pricingBreakdownTitle',
    defaultMessage: 'Pricing Breakdown',
  },
  pricingBreakdown: {
    id: 'locationSection.pricingBreakdownTitle',
    defaultMessage:
      '{price} {guests}. Groups of {discountThreshold} or more get {discountPercent}% off the total price.',
  },
  pricingBreakdownMaxGroupSize: {
    id: 'locationSection.pricingBreakdownMaxGroupsSize',
    defaultMessage: '{price} {guests}. Groups of {discountThreshold} get {discountPercent}% off the total price.',
  },
});
